import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";
import Modal from 'react-responsive-modal';
import axios from 'axios';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import CountUp from 'react-countup';
//import {ChartMenu} from '@ag-grid-enterprise/charts/dist/es6/chartAdaptor/chartComp/menu/chartMenu';
import MarkerClusterer from "@google/markerclusterer";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import ComponentIndex from '../common/appendComponents';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getHyphenDDMMMYYYYHHMM, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import $ from "jquery";
import * as Datetime from 'react-datetime';
import Trucklocaction from './trucklocationnew';
import ReturnLoadPercentage from "./returnLoadPercentage"
var redirectURL = require('../redirectURL');
var moment = require('moment');
var infoBox = require('../common/google-infowindow');
var oms = require(`npm-overlapping-marker-spiderfier/lib/oms.min`);
var googleAnalytics = require("../common/googleanalytics");
var marker;
var markers = [];
var circle;
var selectlat;
var selectlng
var allcords = [];
var map;
var doOnce = true;
var rad = function (x) {
    return x * Math.PI / 180;
};
var rlatitude;
var rlongitude;
var fencingLength = 0;
var geoFencingArea;
var consigners = [];
const decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var decode = decipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
const ITEMS_PER_PAGE = 16;
export default class TrucksWithInGeofence extends Component {
    constructor(props) {
        super(props);
        this.displayData = [];
        this.state = {
            pageTitle: "",
            eventGridAction: "gridAction",
            eventCounterAction: "counterAction",
            eventFormAction: "formAction",
            showform: 'show-m',
            loadshow: 'show-n',
            showrefresh: 'show-n',
            sliderTranslate: '',
            showdata: this.displayData,
            modules: AllModules,
            radius: '15',
            rlatitude: '',
            rlongitude: '',
            latitude: '',
            longitude: '',
            defaultradius: 0,
            coordinates: [],
            alert: null,
            show: false,
            basicTitle: '',
            basicType: "default",
            contentString: "testing",
            mwidth: "col-xl-12 col-lg-12",
            dept_code: '',
            defaultColDef: {
                sortable: true,
                filter: true,
                //editable: true,
                resizable: true
            },
            rowData: [],
            originalrowData: [],
            selectedTabLat: '',
            selectedTabLng: '',
            deftab: 'all',
            deftab1: "Gurgaon",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: false,
            rowSelection: "single",
            context: { componentParent: this },
            loadingCellRenderer: "customLoadingCellRenderer",
            loadingCellRendererParams: { loadingMessage: "One moment please..." },
            rowModelType: "serverSide",
            paginationPageSize: 50,
            cacheBlockSize: 50,
            maxBlocksInCache: 2,
            plant_code: '',
            showPlant: 'show-n',
            showAddr: 'show-n',
            request_type: '',
            view_type: '',
            tabplants: [],
            clickabletab: '',
            plantlist: [],
            stateFormData: "",
            sliderStateEmailsTranslate: "",
            overly: "show-n",
            showStateTrucksMsg: "show-n",
            states_list: [],
            selectedState: [],
            showStates: "show-n",
            showRadius: "show-m",
            usermanualmodal: false,
            plants: [],
            loginplant: "",
            showPreDefinedGeoFence: "show-n",
            geoPlantArr: [],
            plantsArr: [],
            dropDownValue: '',
            frameworkComponents: {
                trucklocaction: Trucklocaction
            },
            // plant_codes: [{ label: "ALL", value: "ALL" }],
            plant_codes: [{ label: "Gurgaon", value: "HHHG" }],
            tpt_codes: [{ label: "ALL", value: "ALL" }],
            plant_codes_optins: [{ label: "Gurgaon", value: "HHHG" }, { label: "Dharuhera", value: "HHHD" }, { label: "Haridwar", value: "HHHU" }, { label: "Neemrana", value: "HM4N" }, { label: "Halol", value: "HM5V" }, { label: "Chittoor", value: "HM6C" },],
            tpt_codes_optins: [{ label: "ALL", value: "ALL" },],
            plant_to_oem_in_range: [],
            today_prediction: [],
            today_trucks: [],
            tomorrow_prediction: [],
            tomorrow_trucks: [],
            oem_trucks: [],
            oem_trucks_tomorrow: [],
            plantgeofenceRadius: 0,
            currentPage: 0,
            ITEMS_PER_PAGE: 16, // default or configurable
            selected_counter: 'today',
            sel_sub_counter: '',
            showAgGrid: false,
            selected_tpt_name: '',
            activeTab: 1,
            startDate: moment().parseZone(new Date()).format("YYYY-MM-DD"),
            fetch_date: moment().parseZone(new Date()).format("YYYY-MM-DD"),
            today_start: 0,
            today_end: 0,
            tom_start: 0,
            tom_end: 0,
            consignments_loaded_trucks: 0,
            noOfHours: new Date().getHours(),
            reported_trucks: [],
            consignments: [],
            showWithInRadius: false,
            with_in_radius: '',
            minRadius: null,
            maxRadius: null,
            radiusError: '',
            todayDate: moment().format("DD-MM-YYYY"),
            tmrwDate: moment().add(1, 'day').format("DD-MM-YYYY"),
            currentHrs: moment().hour(),
            tomorrow_trucks_expected_to_report: "0 - 1",
            today_trucks_expected_to_report: "0 - 1"
        };
        this.popmarker = this.popmarker.bind(this);
        this.cipher = this.cipher.bind(this);
        this.onClickShowTruckLocation = this.onClickShowTruckLocation.bind(this);
        this.onClickShowTab = this.onClickShowTab.bind(this);
        this.changeFileHandlerBulk = this.changeFileHandlerBulk.bind(this);
        this.submitBulkTrucks = this.submitBulkTrucks.bind(this);
        this.handlerStartDateTime = this.handlerStartDateTime.bind(this);
    }
    /*Alert Popups*/
    closeAlert = () => {
        this.setState({
            show: false,
            loadshow: "show-n",
            overly: 'show-n'
        });
    }
    logPageView = () => {
        try {
            if (googleAnalytics.page.enableGA) {
                googleAnalytics.logPageView();
                let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
                let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
                let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
                this.setState({ eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction });
            } else {
                console.log("GA disabled...");
            }
        } catch (error) {
            console.error("Error occured while logging to GA, error = ", error);
        }
    }
    componentDidMount() {
        this.renderMap();
        var loguser = decode(localStorage.getItem("m"));
        var loginplant = "";
        try {
            var luser = JSON.parse(loguser);
            loginplant = luser.is_plant_code;
            // console.log("logplant", loginplant)
            this.setState({
                loginplant: loginplant,
            })
        }
        catch (e) {
        }
        var upath = this.props.match.path.split("/")
        var deptcode = upath[2] || '';
        this.setState({
            dept_code: deptcode,
            overly: "show-m",
            loadshow: "show-m"
        });
        var encode = this.cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
        const p_1 = { dept_code: deptcode.toUpperCase() }
        redirectURL.post("/consignments/plants", p_1)
            .then((resp) => {
                var records = resp.data;
                var plants = [];
                if (records.length > 0) {
                    records.map((item) => {
                        if (loginplant != "" && loginplant != undefined) {
                            if (item.plant_code == loginplant) {
                                plants.push(item);
                            }
                        }
                        else {
                            plants.push(item);
                        }
                    })
                }
                let items = [{ value: "ALL", label: "ALL" }]
                if (plants.length > 0) {
                    plants.forEach(item => {
                        items.push({ value: item.plant_code, label: item.plant_name });
                    });
                }
                this.setState({
                    plantsArr: items,
                    plants: items
                });
            })
        redirectURL.post("/consignments/preDefinedGeoFencePlants").then(plantResp => {
            let geoPlantsList = plantResp.data
            let geoPlantArr = [{ value: "ALL", label: "ALL" }]
            geoPlantsList.map(e => {
                geoPlantArr.push({ value: e, label: e })
            })
            this.setState({
                geoPlantArr
            })
        })
        redirectURL.post("/consignments/getdistincttpt").then(tptResp => {
            let tptList = tptResp.data
            let tptCodeArr = [{ value: "ALL", label: "ALL" }, ...tptList]
            this.setState({
                tpt_codes_optins: tptCodeArr
            })
        })
        let pageTitle = "Vehicle Availability "
        this.setState({ pageTitle: pageTitle });
        this.logPageView(); // Log page view to GA
        redirectURL.post("/vicinity/getDistinctStates").then((response) => {
            this.setState({
                states_list: response.data,
                overly: "show-n",
                loadshow: "show-n"
            });
        }).catch((e) => {
            console.log(e)
        })
        // ✅ Update showRadius based on current startDate and noOfHours
        this.updateShowRadius();
        this.LoadData()
    }
    cipher = (salt) => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        try {
            return text => text.split('')
                .map(textToChars)
                .map(applySaltToChar)
                .map(byteHex)
                .join('');
        }
        // eslint-disable-next-line no-unreachable
        catch (e) { }
    }
    renderMap = () => {
        loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBQUmk7hdajZEAYllxKhVPnUx5pXuK-j_Y&libraries=places,drawing&callback=initMap");
        window.initMap = this.initMap
    }
    onClickShowTruckLocation = (e) => {
        try {
            var lat = parseFloat(e.data.last_address_lat);
            var lng = parseFloat(e.data.last_address_lng);
            var data = e.data;
            map.setCenter(new window.google.maps.LatLng(lat, lng));
            map.setZoom(22);
            var markerLatlng = new window.google.maps.LatLng(lat, lng);
            //var image =  require('../../assets/icons/truckblue.png');
            var image = require('../../assets/icons/gmarker.png');
            var marker = new window.google.maps.Marker({
                position: markerLatlng,
                map: map,
                title: data.truck_no,
                icon: image
            });
            var contentarr = []
            var header = data.truck_no
            //contentarr.push({"key":"Reached On", "value":getDDMMYYYYHHMMSS(data.reached_on)})
            if (data.transporter_name) {
                contentarr.push({ "key": "Transporter Name", "value": data.transporter_name || '' })
            }
            if (data.transporter_code) {
                contentarr.push({ "key": "Transporter Code", "value": data.transporter_code || '' })
            }
            if (data.plant_name) {
                contentarr.push({ "key": "Plant Name", "value": data.plant_name || '' })
            }
            if (data.distance) {
                contentarr.push({ "key": "Distance From Plant (KM) ", "value": data.distance || 0 })
            }
            var contentString = infoBox(marker.icon, header, contentarr, '')
            var infowindow = new window.google.maps.InfoWindow({
                content: contentString
            });
            marker.setAnimation(window.google.maps.Animation.DROP)
            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
            marker.setMap(map);
        } catch (e) {
            console.log("Error", e)
        }
    }
    toggleBounce() {
        if (marker.getAnimation() !== null) {
            marker.setAnimation(null);
        } else {
            marker.setAnimation(window.google.maps.Animation.BOUNCE);
        }
    }
    onCloseRouteDiv() {
        this.setState({
            overly: "show-n",
        })
    }
    initMap = () => {
        try {
            var lt = 28.4519751;
            var ln = 77.0310713;
            let { selected_counter, plant_to_oem_in_range, plantgeofenceRadius, tom_end, tom_start, today_end, today_start, sel_sub_counter, deftab, deftab1 } = this.state
            let geofenceRadius = tom_end
            if (selected_counter == 'today') {
                geofenceRadius = today_end
            }
            plant_to_oem_in_range = plant_to_oem_in_range.filter(item => (item.distance_to_plant <= geofenceRadius || !item.distance_to_plant));
            var currentwindow;
            if (this.state.selectedTabLat != '' && this.state.selectedTabLng != '') {
                var lt = this.state.selectedTabLat;
                var ln = this.state.selectedTabLng;
            }
            else {
                var lt = this.state.rlatitude;
                var ln = this.state.rlongitude;
            }
            map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                zoom: 8,
                center: new window.google.maps.LatLng(lt, ln),
                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
            });
            /*SEARCH END*/
            circle = new window.google.maps.Circle({
                map: map
            });
            marker = new window.google.maps.Marker({
                map: map,
                draggable: true,
                animation: window.google.maps.Animation.DROP,
            });
            marker.addListener('click', function () {
                marker.setAnimation(window.google.maps.Animation.BOUNCE)
            });
            circle.bindTo('center', marker, 'position');
            var markerLatlng1;
            var bounds = new window.google.maps.LatLngBounds();
            var infowindow = new window.google.maps.InfoWindow();
            let geofenceRadiuses = (plantgeofenceRadius == today_end ? today_end : tom_end) * 1000
            let geofenceRadius2 = (plantgeofenceRadius == today_end ? today_start : tom_start) * 1000
            if (sel_sub_counter == 'todayreported') {
                geofenceRadiuses = 5 * 1000
                geofenceRadius2 = 10 * 1000
            }
            console.log(geofenceRadiuses, geofenceRadius2, "check_here123")
            if (doOnce) {
                initOMS();
                doOnce = false;
            }
            if (this.state.rowData.length > 0) {
                var markers = this.state.rowData.map((marker) => {
                    var truckText = ''
                    if (marker.status == 1) {
                        var truckText = "Inside Plant";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_inside_24.png');
                    }
                    else if (marker.status == 2) {
                        var truckText = "Going to Destination";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_going_24.png');
                    }
                    else if (marker.status == 3 || marker.status == 4) {
                        var truckText = "At Destination Location";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_atdealer_24.png');
                    }
                    else if (marker.status == 5) {
                        var truckText = "Left Destination Location";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_leftdealer_24.png');
                    }
                    else if (marker.status == 6) {
                        var truckText = "Return to Plant";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_return_24.png');
                    }
                    else if (marker.status == 7) {
                        var truckText = "Empty Truck Outside Plant";
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_empty_24.png');
                    }
                    else {
                        var truckText = marker.truck_no;
                        var color = "#333333";
                        var image = require('../../assets/icons/truck_na_24.png');
                    }
                    var image = require('../../assets/icons/truck_na_24.png');
                    var contentarr = []
                    var headerTitle = truckText
                    if (marker.transporter_name) {
                        contentarr.push({ "key": "Transporter Name", "value": marker.transporter_name || '' })
                    }
                    if (marker.transporter_code) {
                        contentarr.push({ "key": "Transporter Code", "value": marker.transporter_code || '' })
                    }
                    if (marker.plant_name) {
                        contentarr.push({ "key": "Plant Name", "value": marker.plant_name || '' })
                    }
                    if (marker.distance_to_plant) {
                        contentarr.push({ "key": "Distance From Plant (KM) ", "value": marker.distance_to_plant || 0 })
                    }
                    var contentString = infoBox(image, headerTitle, contentarr, '')
                    //var contentString = "Here "+marker.truck_no;
                    var infowindow = new window.google.maps.InfoWindow({
                        content: contentString
                    });
                    var markerLatlng = new window.google.maps.LatLng(parseFloat(marker.last_address_lat), parseFloat(marker.last_address_lng));
                    bounds.extend(new window.google.maps.LatLng(parseFloat(marker.last_address_lat), parseFloat(marker.last_address_lng)));
                    var image = require('../../assets/icons/truck_na_24.png');
                    if (marker.status == 1) {
                        var image = require('../../assets/icons/truck_inside_24.png');
                    }
                    else if (marker.status == 2) {
                        var image = require('../../assets/icons/truck_going_24.png');
                    }
                    else if (marker.status == 3 || marker.status == 4) {
                        var image = require('../../assets/icons/truck_atdealer_24.png');
                    }
                    else if (marker.status == 5) {
                        var image = require('../../assets/icons/truck_leftdealer_24.png');
                    }
                    else if (marker.status == 6) {
                        var image = require('../../assets/icons/truck_return_24.png');
                    }
                    else if (marker.status == 7) {
                        var image = require('../../assets/icons/truck_empty_24.png');
                    }
                    else {
                        var image = require('../../assets/icons/truck_na_24.png');
                    }
                    var image = require('../../assets/icons/truck_na_24.png');
                    var mark = new window.google.maps.Marker({
                        position: markerLatlng,
                        map: map,
                        title: marker.truck_no,
                        icon: image
                    });
                    mark.addListener('click', function () {
                        infowindow.open(map, mark);
                    });
                    mark.setMap(map);
                    return mark
                });
                var markerCluster = new MarkerClusterer(map, markers,
                    { imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });
            }
            if (plant_to_oem_in_range.length > 0) {
                try {
                    let item = plant_to_oem_in_range[0]
                    let { plant_coordinates } = item
                    markerLatlng1 = new window.google.maps.LatLng(plant_coordinates.lat, plant_coordinates.lng);
                    circle = new window.google.maps.Circle({
                        strokeColor: '#71caab',
                        strokeOpacity: 0.5,
                        strokeWeight: 1,
                        fillColor: '#71caab',
                        fillOpacity: 0.25,
                        map: map,
                        center: markerLatlng1,
                        radius: geofenceRadiuses,
                    });
                    // circle = new window.google.maps.Circle({
                    //     strokeColor: '#71caab',
                    //     strokeOpacity: 0.7,
                    //     strokeWeight: 1,
                    //     fillColor: '#71caab',
                    //     fillOpacity: 0.7,
                    //     map: map,
                    //     center: markerLatlng1,
                    //     radius: geofenceRadius2,
                    // });
                    // bounds.extend(new window.google.maps.LatLng(parseFloat(plant_coordinates.lat), parseFloat(plant_coordinates.lng)));
                    // var mainmark = new window.google.maps.Marker({
                    //     position: new window.google.maps.LatLng(parseFloat(plant_coordinates.lat), parseFloat(plant_coordinates.lng)),
                    //     map: map,
                    //     title: item.plant_code,
                    //     icon: require('../../assets/icons/business.png'),
                    // });
                    // mainmark.addListener('click', () => {
                    //     const contentarr = [];
                    //     const header = "Plant";
                    //     contentarr.push({ key: "Name", value: item.plant_name });
                    //     contentarr.push({ key: "Code", value: item.plant_code });
                    //     const contentString = infoBox("", header, contentarr, "");
                    //     infowindow.setContent(contentString);
                    //     currentwindow = infowindow;
                    //     infowindow.open(map, mainmark);
                    // });
                    if (sel_sub_counter == 'todayreported') {
                    } else {
                        plant_to_oem_in_range.forEach(item => {
                            let { geo_fence_coordinates } = item
                            // 👇 Extra marker from geo_fence_coordinates (no circle)
                            try {
                                if (geo_fence_coordinates && JSON.parse(geo_fence_coordinates)) {
                                    const coord = JSON.parse(geo_fence_coordinates); // Should be an object like { lat: ..., lng: ... }
                                    if (coord.lat && coord.lng) {
                                        const extraMarker = new window.google.maps.Marker({
                                            position: new window.google.maps.LatLng(parseFloat(coord.lat), parseFloat(coord.lng)),
                                            map: map,
                                            title: `${item.geofence_name}`,
                                            icon: "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png" // Optional custom icon
                                        });
                                        extraMarker.addListener('click', () => {
                                            const contentarr = [{ key: "OEM ", value: item.geofence_name }];
                                            const contentString = infoBox("", "", contentarr, "");
                                            infowindow.setContent(contentString);
                                            currentwindow = infowindow;
                                            infowindow.open(map, extraMarker);
                                        });
                                    }
                                }
                            } catch (e) {
                                console.error("Invalid JSON in geo_fence_coordinates", e);
                            }
                            mainmark.setMap(map);
                        })
                    }
                } catch (e) {
                    console.log("Error ", e)
                }
            }
            if (this.state.selectedTabLat != '' && this.state.selectedTabLng != '') {
                if (circle) circle.setMap(null);
                markerLatlng1 = new window.google.maps.LatLng(this.state.selectedTabLat, this.state.selectedTabLng);
                circle = new window.google.maps.Circle({
                    strokeColor: '#71caab',
                    strokeOpacity: 0.7,
                    strokeWeight: 1,
                    fillColor: '#71caab',
                    fillOpacity: 0.25,
                    map: map,
                    center: markerLatlng1,
                    radius: geofenceRadiuses
                });
                bounds.extend(new window.google.maps.LatLng(parseFloat(this.state.selectedTabLat), parseFloat(this.state.selectedTabLng)));
                var mainmark = new window.google.maps.Marker({
                    position: new window.google.maps.LatLng(parseFloat(this.state.selectedTabLat), parseFloat(this.state.selectedTabLng)),
                    map: map,
                    title: deftab,
                    icon: require('../../assets/icons/business.png'),
                });
                mainmark.addListener('click', () => {
                    const contentarr = [];
                    const header = "Plant";
                    contentarr.push({ key: "Name", value: deftab1 });
                    contentarr.push({ key: "Code", value: deftab });
                    const contentString = infoBox("", header, contentarr, "");
                    infowindow.setContent(contentString);
                    currentwindow = infowindow;
                    infowindow.open(map, mainmark);
                });

                mainmark.setMap(map);
                map.setZoom(7);
            }
            else {
                if (this.state.tabplants.length > 0) {
                    this.state.tabplants.forEach(item => {
                        markerLatlng1 = new window.google.maps.LatLng(item.lat, item.lng);
                        circle = new window.google.maps.Circle({
                            strokeColor: '#71caab',
                            strokeOpacity: 0.7,
                            strokeWeight: 1,
                            fillColor: '#71caab',
                            fillOpacity: 0.25,
                            map: map,
                            center: markerLatlng1,
                            radius: geofenceRadiuses
                        });
                        bounds.extend(new window.google.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)));
                        var mainmark = new window.google.maps.Marker({
                            position: new window.google.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)),
                            map: map,
                            title: item.plant_code,
                            icon: require('../../assets/icons/business.png'),
                        });
                        mainmark.addListener('click', () => {
                            const contentarr = [];
                            const header = "Plant";
                            contentarr.push({ key: "Name", value: item.plant_name });
                            contentarr.push({ key: "Code", value: item.plant_code });
                            const contentString = infoBox("", header, contentarr, "");
                            infowindow.setContent(contentString);
                            currentwindow = infowindow;
                            infowindow.open(map, mainmark);
                        })
                        // mainmark.addListener('click', (function () {
                        //     var contentarr = []
                        //     var header = "Plant"
                        //     contentarr.push({ "key": "Code", "value": item.plant_code })

                        //     var contentString = infoBox("", header, contentarr, '')

                        //     infowindow.setContent(contentString);
                        //     currentwindow = infowindow;
                        //     infowindow.open(map, marker);

                        // })
                        // (marker));
                        mainmark.setMap(map);
                    })
                }
            }
            map.fitBounds(bounds)
        }
        catch (e) {
            console.log(e);
        }
    }
    onClickHideAll() {
        this.setState({
            overly: "show-n",
            sliderBulkUpdate: '',
        })
        document.getElementById('uploadFileBulk').value = ''
    }
    popmarker(e) {
        //	console.log("OnClick Table ",e.data)
        var lat = parseFloat(e.data.latitude);
        var lng = parseFloat(e.data.longitude);
        var data = e.data;
        map.setCenter(new window.google.maps.LatLng(lat, lng));
        map.setZoom(22);
        var markerLatlng = new window.google.maps.LatLng(lat, lng);
        //var image =  require('../../assets/icons/truckblue.png');
        var image = require('../../assets/icons/truck_na_24.png');
        if (data.status == 1) {
            var truckText = "Inside Plant";
            var color = "#333333";
            var image = require('../../assets/icons/truck_inside_24.png');
        }
        else if (data.status == 2) {
            var truckText = "Going to Destination";
            var color = "#333333";
            var image = require('../../assets/icons/truck_going_24.png');
        }
        else if (data.status == 3 || data.status == 4) {
            var truckText = "At Destination Location";
            var color = "#333333";
            var image = require('../../assets/icons/truck_atdealer_24.png');
        }
        else if (data.status == 5) {
            var truckText = "Left Destination Location";
            var color = "#333333";
            var image = require('../../assets/icons/truck_leftdealer_24.png');
        }
        else if (data.status == 6) {
            var truckText = "Return to Plant";
            var color = "#333333";
            var image = require('../../assets/icons/truck_return_24.png');
        }
        else if (data.status == 7) {
            var truckText = "Empty Truck Outside Plant";
            var color = "#333333"; var image = require('../../assets/icons/truck_na_24.png');
            var image = require('../../assets/icons/truck_empty_24.png');
        }
        else {
            var truckText = "N/A";
            var color = "#333333";
            var image = require('../../assets/icons/truck_na_24.png');
        }
        var image = require('../../assets/icons/truck_na_24.png');
        var marker = new window.google.maps.Marker({
            position: markerLatlng,
            map: map,
            title: data.truck_no,
            icon: image
        });
        var contentarr = []
        var headerTitle = truckText || ''
        contentarr.push({ "key": "Truck No", "value": data.truck_no });
        contentarr.push({ "key": "Transporter Name", "value": data.transporter_name });
        contentarr.push({ "key": "Distance from geofence", "value": data.distance_from_coordinates });
        //contentarr.push({"key":"LSP Name", "value":data.lsp_name});
        contentarr.push({ "key": "Address", "value": data.area + ", " + data.state });
        var contentString = infoBox(image, headerTitle, contentarr, '')
        var infowindow = new window.google.maps.InfoWindow({
            content: contentString
        });
        marker.setAnimation(window.google.maps.Animation.DROP)
        marker.addListener('click', function () {
            infowindow.open(map, marker);
        });
        marker.setMap(map);
    }
    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };
    LoadData = async () => {
        this.setState({
            loadshow: "show-m",
            overly: 'show-m'
        })
        let { tpt_codes, plant_codes, noOfHours, with_in_radius } = this.state;

        let selected_tpt = Array.isArray(tpt_codes)
            ? tpt_codes.some(item => item.value.toLowerCase() === "all")
                ? []
                : tpt_codes.map(item => item.value)
            : [];

        let selected_plant = Array.isArray(plant_codes)
            ? plant_codes.some(item => item.value.toLowerCase() === "all")
                ? []
                : plant_codes.map(item => item.value)
            : [];

        let date = this.state.startDate || ''
        let payload = {
            plant_code: JSON.stringify(selected_plant),
            // transporter_code: selected_tpt,
            fetch_hour: noOfHours
        }
        if (selected_tpt) {
            payload.transporter_code = JSON.stringify(selected_tpt)
        }
        if (date) {
            payload.fetch_date = date
        }
        if (with_in_radius) {
            if (
                Number(with_in_radius) < this.state.minRadius ||
                Number(with_in_radius) > this.state.maxRadius
            ) {
                this.setState({
                    show: true,
                    basicTitle: `Select radius between ${this.state.minRadius} and ${this.state.maxRadius}`,
                    basicType: 'danger',
                    with_in_radius: "",
                    radiusError: ""
                });
                return;
            } else {
                payload.with_in_radius = with_in_radius;
            }
        }

        redirectURL.post("dashboard/vehicleAvailabilityAtPlantNew", payload).then(response => {
            try {
                let data = response.data
                data = JSON.stringify(data).replaceAll('')
                let { plant_to_oem_in_range = [], today_prediction = [], today_trucks = [], tomorrow_prediction = [], tomorrow_trucks = [], oem_trucks = [], oem_trucks_tomorrow = [], today_start = 0, today_end = 0, tom_start = 0, tom_end = 0, consignments_loaded_trucks = 0, reported_trucks = [], consignments = [], radius_end = 0, tomorrow_trucks_expected_to_report = "0 - 1", today_trucks_expected_to_report = "0 - 1" } = response.data
                console.log(today_prediction, 'today_prediction')
                console.log(today_trucks, 'today_trucks')
                console.log(tomorrow_prediction, 'tomorrow_prediction')
                console.log(tomorrow_trucks, 'tomorrow_trucks')
                console.log(plant_to_oem_in_range, 'plant_to_oem_in_range')
                // Step 1: Extract unique selected plant codes
                const selectedCodes = new Set(this.state.plant_codes.map(p => p.value));

                // Step 2: Build unique filtered centroids from plant_to_oem_in_range in one pass
                const filteredCentroids = [];
                const seenCodes = new Set();

                for (const plant of plant_to_oem_in_range) {
                    const code = plant.plant_code;
                    if (selectedCodes.has(code) && !seenCodes.has(code)) {
                        filteredCentroids.push({
                            lat: plant.plant_coordinates.lat,
                            lng: plant.plant_coordinates.lng,
                            plant_code: code,
                            plant_name: plant.plant_name
                        });
                        seenCodes.add(code);
                    }
                }

                console.log(filteredCentroids, "filteredCentroids")
                var tabplants = [];
                if (plant_to_oem_in_range.length > 0) {
                    console.log(this.state.plant_codes, "check124")
                    filteredCentroids.forEach(item => {
                        // item.label = this.state.plant_codes[0].value;
                        tabplants.push(item);
                    })
                }
                console.log(tabplants, "tabplants321")
                this.setState({
                    plant_to_oem_in_range,
                    tomorrow_prediction,
                    today_prediction,
                    today_trucks,
                    tomorrow_prediction,
                    tomorrow_trucks,
                    oem_trucks,
                    oem_trucks_tomorrow,
                    loadshow: 'show-n',
                    overly: 'show-n',
                    rowData: today_trucks,
                    selected_counter: "today",
                    sel_sub_counter: "",
                    fetch_date: date,
                    today_start,
                    today_end,
                    tom_start,
                    tom_end,
                    plantgeofenceRadius: today_end,
                    consignments_loaded_trucks,
                    reported_trucks,
                    consignments,
                    // minRadius : today_end,
                    minRadius: radius_end,
                    maxRadius: tom_end,
                    tabplants: tabplants,
                    showrefresh: 'show-m',
                    deftab: "all",
                    tomorrow_trucks_expected_to_report,
                    today_trucks_expected_to_report,
                }, async () => {
                    await this.renderMap();
                    // window.initMap = await this.initMap
                })
            } catch (e) {
                console.log("Error ", e)
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                })
            }
        })
    }
    onClickCounter(counter) {
        let { today_end, tom_end, today_trucks, tomorrow_trucks, oem_trucks, oem_trucks_tomorrow, reported_trucks, consignments } = this.state
        if (counter === 'todayTrucks') {
            const oemSet = new Set(oem_trucks.map(truck => truck.truck_no));
            today_trucks = today_trucks.filter(item => !oemSet.has(item.truck_no));
        } else if (counter === 'tomorrowTrucks') {
            const oemTomorrowSet = new Set(oem_trucks_tomorrow.map(truck => truck.truck_no));
            tomorrow_trucks = tomorrow_trucks.filter(item => !oemTomorrowSet.has(item.truck_no));
        }
        let rowData = []
        if (counter == 'tomorrowvicinity') {
            rowData = [...tomorrow_trucks, ...oem_trucks_tomorrow]
        } else if (counter == 'todayvicinity') {
            rowData = [...today_trucks, ...oem_trucks]
        }
        const config = {
            todayTrucks: {
                rowData: today_trucks,
                originalrowData: today_trucks,
                deftab: "all",
                plantgeofenceRadius: today_end,
                selected_counter: "today",
                sel_sub_counter: "todayestimatedtrucks",
                currentPage: 0,
            },
            tomorrowTrucks: {
                rowData: tomorrow_trucks,
                originalrowData: tomorrow_trucks,
                deftab: "all",
                plantgeofenceRadius: tom_end,
                selected_counter: "tomorrow",
                sel_sub_counter: "tomorrowestimatedtrucks",
                currentPage: 0,
            },
            todayvicinity: {
                rowData: rowData,
                originalrowData: rowData,
                deftab: "all",
                plantgeofenceRadius: today_end,
                showAgGrid: true,
                selected_counter: "today",
                sel_sub_counter: "todayvicinity",
                scroll: true,
            },
            todaygeofence: {
                rowData: this.state.oem_trucks,
                originalrowData: this.state.oem_trucks,
                deftab: "all",
                plantgeofenceRadius: today_end,
                showAgGrid: true,
                selected_counter: "today",
                sel_sub_counter: "todaygeofence",
                scroll: true,
            },
            tomorrowvicinity: {
                rowData: rowData,
                originalrowData: rowData,
                deftab: "all",
                plantgeofenceRadius: tom_end,
                showAgGrid: true,
                selected_counter: "tomorrow",
                sel_sub_counter: "tomorrowvicinity",
                scroll: true,
            },
            tomorrowgeofence: {
                rowData: this.state.oem_trucks_tomorrow,
                originalrowData: this.state.oem_trucks_tomorrow,
                deftab: "all",
                plantgeofenceRadius: tom_end,
                showAgGrid: true,
                selected_counter: "tomorrow",
                sel_sub_counter: "tomorrowgeofence",
                scroll: true,
            },
            plantParking: {
                rowData: reported_trucks,
                originalrowData: reported_trucks,
                deftab: "all",
                plantgeofenceRadius: today_end,
                showAgGrid: true,
                selected_counter: "today",
                sel_sub_counter: "todayreported",
                scroll: true,
            },
            loaded_trucks: {
                rowData: consignments,
                originalrowData: consignments,
                deftab: "all",
                plantgeofenceRadius: today_end,
                showAgGrid: true,
                selected_counter: "today",
                sel_sub_counter: "todayloadedtrucks",
                scroll: true,
            },
        };
        const settings = config[counter];
        if (!settings) return;
        this.setState(settings, async () => {
            await this.renderMap();
            if (settings.scroll) {
                const container = document.getElementById("gridMapContainer");
                if (container) {
                    container.scrollIntoView({ behavior: "smooth" });
                }
            }
        });
    }
    handleBarClick = (pointData) => {
        try {
            console.log(pointData, 'pointData')
            const tptCode = pointData.transporter_code;
            const selectedFilter = this.state.selected_counter;
            const { today_trucks, tomorrow_trucks } = this.state;
            const sourceData = selectedFilter === 'today' ? today_trucks : tomorrow_trucks;
            const filtered = sourceData.filter(item => item.transporter_code === tptCode);
            this.setState({
                rowData: filtered,
                showAgGrid: true,
                sel_sub_counter: 'tpt_highcharts',
                selected_tpt_name: pointData.name
            }, () => {
                this.renderMap()
            });
            const container = document.getElementById('gridMapContainer');
            if (container) {
                container.scrollIntoView({ behavior: 'smooth' });
            }
            // alert(`Transporter: ${pointData.name}\nCode: ${pointData.transporter_code}\nActual Trucks: ${pointData.count}`);
        } catch (e) {
            console.error('Error handling transporter click:', e);
        }
    };
    onClickShowTab = (tabValue) => {
        try {
            let activeTab = this.state.activeTab
            let tab = parseInt(tabValue)  // Renamed parameter to tabValue and local variable to tab
            if (tab == 1 && activeTab !== tab) {
                this.setState({
                    activeTab: tab,
                    pageTitle: 'Truck Availability',
                })
                this.LoadData();
            } else if (tab == 2 && activeTab !== tab) {
                this.setState({
                    activeTab: tab,
                    pageTitle: 'Return Load Percentage',
                })
            }
        } catch (e) {
            console.log("Error ", e)
        }
    }
    onClickBulkForm() {
        this.setState({
            sliderBulkUpdate: "slider-translate",
            overly: "show-m",
            // loadshow:"show-m",
        })
    }
    changeFileHandlerBulk = async (e) => {
        //  console.log(e.target.files[0])
        const fileInput = document.getElementById('uploadFileBulk');
        const filePath = fileInput.value;
        const allowedExtensions = /(\.xls|\.xlsx)$/i; // Regular expression for .xls and .xlsx file extensions
        if (!allowedExtensions.exec(filePath)) {
            this.setState({
                show: true,
                basicTitle: 'Invalid file type. Please provide an .xls or .xlsx file.',
                basicType: "info"
            })
            fileInput.value = ''; // Clear the input
            return false;
        }
        this.setState({
            matrixFile: e.target.files[0]
        });
    }
    submitBulkTrucks = async (event) => {
        try {
            event.preventDefault();
            if (!this.state.matrixFile) {
                this.setState({
                    show: true,
                    basicTitle: "Please Upload File and Submit",
                    basicType: 'danger',
                })
                return ""
            }
            let { tpt_codes, plant_codes } = this.state;
            let selected_tpt = Array.isArray(tpt_codes)
                ? tpt_codes.some(item => item.value.toLowerCase() === "all")
                    ? []
                    : tpt_codes.map(item => item.value)
                : [];

            let selected_plant = Array.isArray(plant_codes)
                ? plant_codes.some(item => item.value.toLowerCase() === "all")
                    ? []
                    : plant_codes.map(item => item.value)
                : [];
            let date = this.state.startDate || ''
            let payload = {
                plant_code: selected_plant,
                transporter_code: selected_tpt,
                created_by: localStorage.getItem('email') || ''
            }
            if (date) {
                payload.fetch_date = date
            }
            this.setState({ loadshow: "show-m" });
            const fdata = new FormData();
            fdata.append("uploadfile", this.state.matrixFile);            //
            fdata.append('payload', JSON.stringify(payload))
            // Send file to server
            const resp = await redirectURL.post("/dashboard/submitBulkUploadTrucksAvailability", fdata, {
                headers: {
                    'cache-control': 'no-cache',
                    'content-type': 'multipart/form-data'
                }
            });
            const excelData = resp.data.records || [];
            let duplicatesMsg = resp.data.duplicatesMsg || false;
            if (duplicatesMsg.length) {
                this.setState({
                    rowData: excelData,
                    show: true,
                    basicTitle: duplicatesMsg || 'Duplicate Records Found',
                    basicType: 'danger',
                })
            } else {
                this.setState({
                    show: true,
                    basicTitle: 'Uploaded Successfully',
                    basicType: 'success',
                })
            }
            this.setState({
                rowData: excelData,
                loadshow: "show-n",
                overly: "show-n",
                sliderBulkUpdate: "",
            })
            document.getElementById("uploadFileBulk").value = ""
        } catch (error) {
            console.error('Error during submitBulkTrucks:', error);
        }
    };
    handlerStartDateTime = (event) => {
        const newStartMoment = moment(event._d);
        this.setState({ startDate: newStartMoment.format('YYYY-MM-DD') }, this.updateShowRadius);
    };
    onNoOfHoursChanged = (event) => {
        try {
            this.setState({
                noOfHours: event.value
            }, this.updateShowRadius);
        } catch (e) {
            console.log("Error :", e);
        }
    }

    onRadiusChanged = (event) => {
        const { minRadius, maxRadius } = this.state;
        const value = event.target.value;

        // Reset error
        this.setState({ radiusError: '' });

        // Allow only digits (including empty)
        if (/^\d*$/.test(value)) {
            if (value === '') {
                this.setState({ with_in_radius: '' });
                return;
            }

            const numericValue = parseInt(value, 10);

            // Validate range
            if (numericValue > minRadius && numericValue < maxRadius) {
                this.setState({ with_in_radius: value });
            } else {
                this.setState({
                    with_in_radius: value, // Still update so user can fix it
                    radiusError: `Enter Radius Between ${minRadius}-${maxRadius}`,
                });
            }
        }
    };




    updateShowRadius = () => {
        const { startDate, noOfHours } = this.state;
        const today = moment().format('YYYY-MM-DD');
        const currentHour = moment().hour();
        const shouldShow = startDate === today && Number(noOfHours) === currentHour;
        console.log("shouldShow", shouldShow);
        this.setState({
            showWithInRadius: shouldShow,  // ✅ Correct key used here
            with_in_radius: shouldShow ? this.state.with_in_radius : ''
        });
    };

    onClickShowMap = async (tabcode) => {
        console.log("tabcode ", tabcode)
        var dataarray = [];
        if (tabcode != 'all') {
            await this.state.originalrowData.map((item) => {
                if (
                    item && tabcode &&
                    ((item.plant_code && item.plant_code === tabcode.plant_code) ||
                        (item.consigner_code && item.consigner_code === tabcode.plant_code))
                ) {
                    dataarray.push(item);
                }
            });
            await this.setState({
                rowData: dataarray,
                selectedTabLat: tabcode.lat,
                selectedTabLng: tabcode.lng,
                deftab: tabcode.plant_code,
                deftab1: tabcode.plant_name
            });

            if (this.gridColumnApi) {
                this.gridColumnApi.setColumnsVisible(["plant_code"], false);
            }

        }
        else {
            await this.setState({
                rowData: this.state.originalrowData,
                selectedTabLat: "",
                selectedTabLng: "",
                deftab: "all"
            });
            if (this.gridColumnApi) {
                this.gridColumnApi.setColumnsVisible(["plant_code"], true);
            }


        }
        await this.renderMap();
    }




    render() {
        let localMail = localStorage.getItem('email') || ''
        let { today_trucks, tomorrow_trucks, oem_trucks, selected_counter, oem_trucks_tomorrow, sel_sub_counter, currentPage, selected_tpt_name, today_prediction, tomorrow_prediction, activeTab, startDate, fetch_date, today_start = 0, today_end = 0, tom_start = 0, tom_end = 0, consignments_loaded_trucks = 0, noOfHours, reported_trucks, rowData, todayDate, tmrwDate, currentHrs, tomorrow_trucks_expected_to_report = "0 - 1", today_trucks_expected_to_report = "0 - 1" } = this.state
        today_prediction = Array.isArray(today_prediction) ? "0 - 1" : today_prediction
        tomorrow_prediction = Array.isArray(tomorrow_prediction) ? "0 - 1" : tomorrow_prediction
        const currentHrss = noOfHours
        // const ordinal = formatTillHour(currentHrss);
        const number = formatTillHour(currentHrss);
        // const suffix = ordinal.replace(number, "");
        const currentHour = new Date().getHours();
        const todayStr = new Date().toISOString().split("T")[0];
        const istoday = this.state.startDate === todayStr;

        const endHour = istoday ? currentHour : 23;

        const hoursOptions = Array.from({ length: endHour - 5 }, (_, i) => {
            const hour = i + 6;
            return {
                value: hour,
                label: hour
            };
        });


        let startDateFormatted = moment(fetch_date).format('YYYY-MM-DD');
        let currentDateFormatted = moment().utcOffset('+05:30').format('YYYY-MM-DD');
        let isToday = startDateFormatted === currentDateFormatted;
        let rowDataForColumnChart = this.state.rowData
        if (selected_counter == 'today') {
            rowDataForColumnChart = today_trucks
        } else {
            rowDataForColumnChart = tomorrow_trucks
        }
        let vicinityCount = today_trucks.length || 0
        let tomorrowVicinityCount = tomorrow_trucks.length || 0
        let oemCount = oem_trucks.length || 0
        let tmwoemcount = oem_trucks_tomorrow.length || 0
        // Group by transporter
        const transporterMap = rowDataForColumnChart.reduce((acc, truck) => {
            const { transporter_code, transporter_name } = truck;
            if (!acc[transporter_code]) {
                acc[transporter_code] = {
                    transporter_code,
                    transporter_name,
                    count: 0,
                };
            }
            acc[transporter_code].count += 1;
            return acc;
        }, {});
        const groupedData = Object.values(transporterMap).sort((a, b) => b.count - a.count);
        // Pagination
        const totalPages = Math.ceil(groupedData.length / ITEMS_PER_PAGE);
        const paginatedData = groupedData.slice(
            currentPage * ITEMS_PER_PAGE,
            (currentPage + 1) * ITEMS_PER_PAGE
        );
        // Y-axis range based on truck counts
        const truckCounts = paginatedData.map(entry => entry.count);
        const minY = Math.floor(Math.min(...truckCounts) * 0.8);
        const maxY = Math.ceil(Math.max(...truckCounts) * 1);
        // Chart categories and data
        const categories = paginatedData.map(
            (entry) => `${entry.transporter_name} (${entry.transporter_code})`
        );
        const paginatedTotal = paginatedData.reduce((sum, entry) => sum + entry.count, 0);
        const overallTotal = groupedData.reduce((sum, entry) => sum + entry.count, 0); // <== NEW
        const data = paginatedData.map((entry, index) => {
            const count = entry.count;
            const low = count === 0 ? 0 : Math.floor(count * 0.8);
            const high = count === 0 ? 1 : Math.ceil(count * 1);
            const percentage = overallTotal === 0 ? 0 : ((count / overallTotal) * 100).toFixed(1); // <== MODIFIED
            return {
                name: `${entry.transporter_name} (${entry.transporter_code})`,
                y: count,
                count,
                percentage,
                rangeLabel: `${low} - ${high}`,
                transporter_code: entry.transporter_code,
                color: count === 0
                    ? '#e0e0e0'
                    : Highcharts.getOptions().colors[index % Highcharts.getOptions().colors.length],
            };
        });
        let isTodayOrNot = this.state.selected_counter === "today" ? (isToday ? "Today" : "") : "Tomorrow";
        const options = {
            chart: {
                type: 'column',
            },
            title: {
                text: `${isTodayOrNot} Transporter wise Estimated Trucks`,
            },
            xAxis: {
                categories: categories,
                title: {
                    text: 'Transporters',
                },
                labels: {
                    style: {
                        fontSize: '12px',
                    },
                },
            },
            yAxis: {
                min: minY,
                max: maxY,
                title: {
                    text: 'Number of Trucks',
                },
                labels: {
                    format: '{value}',
                },
            },
            tooltip: {
                useHTML: true,
                formatter: function () {
                    return `
                        <b>${this.point.name}</b><br/>
                        Estimated Trucks: <b>${this.point.rangeLabel}</b><br/>
                        Percentage: <b>${this.point.percentage}%</b>
                    `;
                },
            },
            plotOptions: {
                column: {
                    colorByPoint: true,
                    dataLabels: [
                        {
                            enabled: true,
                            formatter: function () {
                                return `${this.point.rangeLabel}`;
                            },
                            style: {
                                fontWeight: 'bold',
                                fontSize: '12px',
                                color: '#333',
                            },
                            inside: false, // Show on top
                            verticalAlign: 'top',
                            y: -20,
                        },
                        {
                            enabled: true,
                            formatter: function () {
                                return `${this.point.percentage}%`;
                            },
                            inside: true,
                            verticalAlign: 'middle',
                            style: {
                                fontWeight: 'bold',
                                fontSize: '11px',
                                color: '#ffffff',
                            },
                        }
                    ]
                },
                series: {
                    point: {
                        events: {
                            click: (event) => this.handleBarClick(event.point),
                        },
                    },
                },
            },
            legend: {
                enabled: false,
            },
            series: [
                {
                    name: 'Trucks',
                    data: data,
                },
            ],
        };
        let hideColmnsFor = sel_sub_counter == 'todayloadedtrucks' || sel_sub_counter == 'todayreported'
        let hideColmnsForConsignments = sel_sub_counter == 'todayloadedtrucks'
        var columnDefs = [
            {
                headerName: "",
                field: "",
                width: 50,
                //   cellRenderer:'trucklocaction'
                cellRendererSelector: function (params) {
                    if (params.data._id != "total") {
                        return {
                            component: "trucklocaction"
                        }
                    }
                },
                hide: hideColmnsForConsignments || !isToday,
                suppressColumnsToolPanel: hideColmnsForConsignments || !isToday,
            },
            {
                headerName: "Truck No",
                field: "truck_no",
                width: 140,
            },
            {
                headerName: "Latitude",
                field: "lat",
                width: 120,
                filter: true,
                resizable: true,
                valueGetter: function (params) {
                    try {
                        let { last_address_lat = '' } = params.data
                        return last_address_lat;
                    } catch (e) {
                        console.log("Error ", e)
                    }
                },
                hide: hideColmnsForConsignments,
                suppressColumnsToolPanel: hideColmnsForConsignments,
            },
            {
                headerName: "Longitude",
                field: "lng",
                width: 120,
                filter: true,
                resizable: true,
                valueGetter: function (params) {
                    try {
                        let { last_address_lng = '' } = params.data
                        return last_address_lng;
                    } catch (e) {
                        console.log("Error ", e)
                    }
                }
                ,
                hide: hideColmnsForConsignments,
                suppressColumnsToolPanel: hideColmnsForConsignments,
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 120,
                filter: true,
                resizable: true,
                valueGetter: function (params) {
                    try {
                        let { transporter_code = '' } = params.data
                        return transporter_code;
                    } catch (e) {
                        console.log("Error ", e)
                    }
                }
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name",
                width: 220,
                filter: true,
                resizable: true,
                valueGetter: function (params) {
                    try {
                        let { transporter_name = '' } = params.data
                        return transporter_name;
                    } catch (e) {
                        console.log("Error ", e)
                    }
                }
            },
            {
                headerName: "Distance From Plant",
                field: "distance_to_plant",
                width: 120,
                filter: true,
                resizable: true,
                hide: hideColmnsFor,
                suppressColumnsToolPanel: hideColmnsFor,
                valueGetter: function (params) {
                    try {
                        let { distance_to_plant = '' } = params.data
                        if (distance_to_plant) {
                            distance_to_plant = Math.ceil(distance_to_plant);
                        }
                        return distance_to_plant;
                    } catch (e) {
                        console.log("Error ", e)
                    }
                }
            },
            {
                headerName: "Plant Name",
                field: "plant_name",
                width: 140,
                filter: true,
                resizable: true,
                valueGetter: function (params) {
                    try {
                        let { plant_name = '' } = params.data
                        return plant_name;
                    } catch (e) {
                        console.log("Error ", e)
                    }
                },
                hide: hideColmnsForConsignments,
                suppressColumnsToolPanel: hideColmnsForConsignments,
            },
        ];
        if (sel_sub_counter == 'todayreported') {
            columnDefs.push(
                {
                    headerName: "Parking Name",
                    field: "parking_name",
                    width: 180,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { parking_name = '' } = params.data
                            return parking_name;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Reported At",
                    field: "reported_at",
                    width: 180,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { reported_at = '' } = params.data
                            return reported_at;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
            )
        } else if (sel_sub_counter == 'todayloadedtrucks') {
            columnDefs.push(
                {
                    headerName: "Consignee Name",
                    field: "consignee_name",
                    width: 180,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { consignee_name = '' } = params.data
                            return consignee_name;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Consignee Code",
                    field: "consignee_code",
                    width: 160,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { consignee_code = '' } = params.data
                            return consignee_code;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Consignee Area",
                    field: "consignee_area",
                    width: 160,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { consignee_area = '' } = params.data
                            return consignee_area;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Consignee City",
                    field: "consignee_city",
                    width: 160,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { consignee_city = '' } = params.data
                            return consignee_city;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Consignee State",
                    field: "consignee_state",
                    width: 140,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { consignee_state = '' } = params.data
                            return consignee_state;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Consignment Code",
                    field: "consignment_code",
                    width: 180,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { consignment_code = '' } = params.data
                            return consignment_code;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Distance (KM)",
                    field: "distance_in_km",
                    width: 120,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { distance_in_km = '' } = params.data
                            return distance_in_km;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Invoice No",
                    field: "invoice_no",
                    width: 120,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { invoice_no = '' } = params.data
                            return invoice_no;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Invoice Time",
                    field: "invoice_time",
                    width: 180,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { invoice_time = '' } = params.data
                            return invoice_time;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
            )
        } else if (sel_sub_counter == 'tomorrowgeofence' || sel_sub_counter == 'todaygeofence') {
            columnDefs.push(
                {
                    headerName: "Geofence Name",
                    field: "geofence_name",
                    width: 140,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { geofence_name = '' } = params.data
                            return geofence_name;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Geofence Duration ",
                    field: "geofence_duration",
                    width: 180,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { geofence_duration = '' } = params.data
                            return secondsToHoursFormat(geofence_duration)
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Geofence In",
                    field: "geofence_in",
                    width: 220,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { geofence_in = '' } = params.data
                            return geofence_in;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
                {
                    headerName: "Geofence Out",
                    field: "geofence_out",
                    width: 220,
                    filter: true,
                    resizable: true,
                    valueGetter: function (params) {
                        try {
                            let { geofence_out = '' } = params.data
                            return geofence_out;
                        } catch (e) {
                            console.log("Error ", e)
                        }
                    }
                },
            )
        }
        const dStyles = {
            width: '100%',
            marginLeft: '0px',
            paddingLeft: '0px',
            height: '500px'
        }
        let day = selected_counter === "today" ? "Today" : "Tomorrow";
        if (!isToday) {
            day = moment(startDate).format('DD-MMM-YYYY')
        }
        const titleMap = {
            tomorrowvicinity: ` - Trucks within Vicinity (Outside parking) ( ${tom_start} - ${tom_end} KMS)`,
            // todaygeofence: " - Load Taken From Others (in Last 24hrs)",
            // tomorrowgeofence: " - Load Taken From Others (in Last 24hrs)",
            todaygeofence: " - Probable Truck Arrivals",
            tomorrowgeofence: " - Carried Forward Trucks",
            tpt_highcharts: " - " + selected_tpt_name,
            tomorrowestimatedtrucks: `- Trucks within Vicinity (Outside parking) ( ${tom_start} - ${tom_end} KMS)`,
            todayestimatedtrucks: `- Trucks within Vicinity (Outside parking) ( 5 - ${today_end} KMS)`,
            todayreported: ` - At Parking Geofence( 0 - 5 KMS)`,
            todayloadedtrucks: ` - Loaded Trucks (Hours) `,
        };
        const defaultTitle = ` - Trucks within Vicinity (Outside parking) ( 5 - ${today_end} KMS)`;
        const map_container_title = `${day}${titleMap[sel_sub_counter] || defaultTitle}`;
        function updateTodayVicinity(today_prediction, oem_trucks, today_trucks = [], isToday = false) {
            // Convert to string if it's a number
            if (today_prediction == null) return "0";
            const predictionStr = String(today_prediction).trim();
            if (predictionStr === "0") {
                return "0";
            }
            const parts = predictionStr.split("-");
            if (parts.length !== 2) return predictionStr; // Fallback if format is unexpected        
            const [start, end] = parts.map(Number);
            const oemCount = Array.isArray(oem_trucks) ? oem_trucks.length : 0;

            // For today only: use today_trucks.length * 0.8
            if (isToday && Array.isArray(today_trucks)) {
                const todatTrucksCount = Array.isArray(today_trucks) ? today_trucks.length : 0;
                var endCount = todatTrucksCount + oemCount
                const approx = Math.round(endCount * 0.8); // Rounded for cleaner display
                return `${approx}-${endCount}`;
            }

            const updatedEnd = end + oemCount;
            return `${start}-${updatedEnd}`;
        }
        const todayvicinity = updateTodayVicinity(today_prediction, oem_trucks, today_trucks, true);
        const tomorrowyvicinity = updateTodayVicinity(tomorrow_prediction, oem_trucks_tomorrow, tomorrow_trucks, true);
        const renderAgGrid = () => {
            try {
                return (
                    <div id="myGrid" style={{ height: "480px", width: "100%" }} className="ag-theme-balham">
                        <AgGridReact
                            modules={this.state.modules}
                            columnDefs={columnDefs}
                            defaultColDef={this.state.defaultColDef}
                            rowData={rowData}
                            enableCharts={false}
                            enableRangeSelection={false}
                            autoGroupColumnDef={this.state.autoGroupColumnDef}
                            onGridReady={this.onGridReady}
                            onGridState={this.onGridState}
                            statusBar={this.state.statusBar}
                            sideBar={this.state.sideBar}
                            paginationPageSize={this.state.paginationPageSize}
                            pagination={true}
                            context={{ componentParent: this }} // ✅ this is key!
                            // enableRangeSelection={false}
                            floatingFilter={false}
                            onCellClicked={this.popmarker}
                            frameworkComponents={this.state.frameworkComponents}
                        />
                    </div>
                )
            } catch (e) {
                console.log("Error ", e)
            }
        }
        return (
            <div className="container-fluid">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                {this.state.alert}
                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className='row p-0 m-0' style={{ display: 'flex', justifyContent: "space-between" }} >
                            <ul className="ul-tabs mt-25p mb-0" >
                                <li style={{ padding: '0px', margin: '0px' }}>
                                    <a
                                        href="javascript:;"
                                        className={"p-0 pl-2 pr-2 btn " + (activeTab == 1 ? 'btn-danger text-white' : 'btn-default bg-white')}
                                        id="truckAvailability"
                                        onClick={() => this.onClickShowTab('1')} // Use an arrow function
                                    >
                                        Prediction of Empty Truck Availability
                                    </a>
                                </li>
                                <li style={{ padding: '0px', margin: '0px' }}>
                                    <a
                                        href="javascript:;"
                                        className={"p-0 pl-2 pr-2 btn " + (activeTab == 2 ? 'btn-danger text-white' : 'btn-default bg-white')}
                                        id="loadPercentage"
                                        onClick={() => this.onClickShowTab('2')} // Use an arrow function
                                    >
                                        Return Load Percentage
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="card">
                            <div className="card-header pb-0">
                                <div className='row p-0 m-0' style={{ display: 'flex', justifyContent: "space-between" }} >
                                    <h5>
                                        <i className="icofont icofont-vehicle-delivery-van cus-i"></i>
                                        <span>{this.state.pageTitle} </span>
                                        <span className="col-xl-12 col-lg-12 pull-right" style={{ fontSize: "12px", marginBottom: "14px" }}>
                                        </span>
                                    </h5>
                                    {/* {
                                        localMail && localMail.toLocaleLowerCase().includes('enmovil') && activeTab == 1 &&
                                        <button
                                            type="button"
                                            className="btn btn-warning form-group "
                                            style={{ fontSize: "14px", padding: "5px", width: "100px", height: "36px", borderRadius: "6px", marginBottom: "0px" }}
                                            onClick={this.onClickBulkForm.bind(this)}>
                                            File Upload
                                        </button>
                                    } */}
                                </div>
                            </div>
                            {activeTab == 1 &&
                                <>
                                    <div className='row m-0'>
                                        <form className={"d-flex theme-form col-xl-12 col-lg-12 mb-2 mt-2"} >
                                            <div className="col-xl-2 col-lg-2 form-group">
                                                <label className="c-lbl" htmlFor="startDate">Date</label>
                                                <Datetime
                                                    timeFormat={false}  // Disable time selection
                                                    closeOnSelect={true}
                                                    inputProps={{
                                                        placeholder: 'From Date',
                                                        name: 'startDate',
                                                        id: 'startDate',
                                                        autoComplete: 'off',
                                                        readOnly: true,
                                                        value: startDate
                                                    }}
                                                    dateFormat="YYYY-MM-DD"
                                                    className='date-z-index'
                                                    onChange={this.handlerStartDateTime}
                                                />
                                            </div>
                                            <div className="form-group col-xl-2 col-lg-2" >
                                                <label className="c-lbl" htmlFor="noOfHours" style={{ marginBottom: '5px' }}>Hour<span style={{ color: 'red' }}></span></label>
                                                <Select
                                                    placeholder="Select Hour"
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="noOfHours"
                                                    value={{
                                                        label: moment({ hour: noOfHours }).format('HH:00'),
                                                        value: noOfHours
                                                    }}
                                                    onChange={this.onNoOfHoursChanged}
                                                    options={hoursOptions}
                                                    getOptionLabel={(e) => `${moment({ hour: e.value }).format('HH:00')}`}
                                                />

                                            </div>
                                            <div className='col-2'>
                                                <label className="c-lbl" htmlFor='plant_code'>Select Plant</label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    name="plant_code"
                                                    isMulti={true}
                                                    placeholder="ALL"
                                                    // className="form-control"
                                                    value={this.state.plant_codes}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            plant_codes: e
                                                        })
                                                    }}
                                                    options={this.state.plant_codes_optins} />
                                            </div>
                                            <div className='col-2'>
                                                <label className="c-lbl" htmlFor='tpt_codes'>Select Transporter</label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    name="tpt_codes"
                                                    isMulti={true}
                                                    placeholder="ALL"
                                                    // className="form-control"
                                                    value={this.state.tpt_codes}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            tpt_codes: e
                                                        })
                                                    }}
                                                    options={this.state.tpt_codes_optins} />
                                            </div>
                                            {this.state.showWithInRadius && (
                                                <div className="col-xl-2 col-lg-2 form-group">
                                                    <label className="c-lbl" htmlFor="with_in_radius">Select Radius</label>
                                                    <input
                                                        type="number"
                                                        name="with_in_radius"
                                                        id="with_in_radius"
                                                        className="form-control"
                                                        value={this.state.with_in_radius}
                                                        onChange={this.onRadiusChanged}
                                                        placeholder={`Enter radius (${this.state.minRadius} - ${this.state.maxRadius})`}
                                                        min={this.state.minRadius}
                                                        max={this.state.maxRadius}
                                                    />
                                                    {this.state.radiusError && (
                                                        <small style={{ color: 'red', marginTop: '4px', display: 'block' }}>
                                                            {this.state.radiusError}
                                                        </small>
                                                    )}
                                                </div>
                                            )}

                                            <div className='col-3' style={{ alignContent: 'center', marginTop: '10px' }}>
                                                <label className="c-lbl" htmlFor='btn'>    </label>
                                                <button className='btn btn-success' type="button" onClick={() => {
                                                    this.LoadData()
                                                }}>Submit</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="card-body row m-0">
                                        <div className="row" style={{ width: '100%', margin: '0px' }}>
                                            <div className="col-xl-12 col-lg-12 col-sm-12 beffect p-0">
                                                <div className="card">
                                                    <div className="card-body p-2">
                                                        <div className="crm-numbers pb-0">
                                                            <div className="row" style={{ marginBottom: '18px' }}>
                                                                <div className="col " >
                                                                    <div className="col cursorPointer" style={{ marginTop: "16px" }} onClick={this.onClickCounter.bind(this, "todayTrucks")}>
                                                                        <span className="f14">{isToday ? `Trucks Expected Today (${todayDate})` : "Estimated Trucks"}</span>
                                                                        <h4 className="txt-info f30"><span className="counter bouncy-text-once">{today_prediction} </span></h4>
                                                                    </div>
                                                                    <div className="crm-numbers pb-0">
                                                                        <div className="row" style={{ marginTop: '18px' }}>
                                                                            <div className="col cursorPointer" onClick={this.onClickCounter.bind(this, "todayvicinity")}>
                                                                                <span className="f14">Trucks within Vicinity <br /> (Outside parking) <br /> ( 5 - {today_end} KMS)</span>
                                                                                <h4 className="txt-danger f30"><span className="counter txt-danger">{todayvicinity}</span></h4>
                                                                            </div>
                                                                            <div className="col cursorPointer"
                                                                            // onClick={this.onClickCounter.bind(this, "todaygeofence")}
                                                                            >
                                                                                {/* <span className="f14">Load Taken From Other <br /> OEMs in  Last 24hrs</span>*/}
                                                                                <span className="f14">Probable Truck Arrivals </span>
                                                                                <div style={{ margin: '21px 0' }}></div>
                                                                                {/* <h4 className="txt-warning f30"><span className="counter "><CountUp className="txt-warning" end={oemCount} /> </span></h4> */}
                                                                                <br />
                                                                                <h4 className="txt-warning f30"><span className="counter txt-warning">{today_trucks_expected_to_report}</span></h4>
                                                                            </div>
                                                                            <div className="col cursorPointer"
                                                                                onClick={this.onClickCounter.bind(this, "loaded_trucks")}
                                                                                style={{ maxWidth: '20%' }}
                                                                            >
                                                                                <span className="f14">Loaded Trucks <br />({number})</span>
                                                                                <div style={{ margin: '21px 0' }}></div> {/* Adds vertical spacing */}
                                                                                <h4 className="txt-warning f30"><span className="counter "><CountUp className="txt-primary" end={consignments_loaded_trucks} /> </span></h4>
                                                                            </div>
                                                                            <div className="col cursorPointer"
                                                                                onClick={this.onClickCounter.bind(this, "plantParking")}
                                                                                style={{ maxWidth: '20%' }}

                                                                            >
                                                                                <span className="f14">At Parking Reported in<br />(0-5km) </span>
                                                                                <div style={{ margin: '0px 0' }}></div> {/* Adds vertical spacing */}
                                                                                <h4 className="txt-warning f30"><span className="counter "><CountUp className="txt-success" end={reported_trucks.length || 0} /> </span></h4>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    isToday &&
                                                                    <div className="col " style={{ maxWidth: '40%' }}>
                                                                        <div className="col cursorPointer" style={{ marginTop: "16px" }} onClick={this.onClickCounter.bind(this, "tomorrowTrucks")}>
                                                                            <span className="f14">Trucks Expected Tomorrow ({tmrwDate})</span>
                                                                            <h4 className="txt-info f30"><span className="counter bouncy-text-once">{(tomorrow_prediction) || "0 - 1"}</span></h4>
                                                                        </div>
                                                                        <div className="crm-numbers pb-0">
                                                                            <div className="row" style={{ marginTop: '18px' }}>
                                                                                <div className="col cursorPointer" onClick={this.onClickCounter.bind(this, "tomorrowvicinity")}>
                                                                                    <span className="f14">Trucks within Vicinity <br /> (Outside parking) <br /> ( {tom_start} - {tom_end} KMS)</span>
                                                                                    <h4 className="txt-danger f30"><span className="counter txt-danger">{tomorrowyvicinity}</span></h4>
                                                                                </div>
                                                                                <div className="col cursorPointer"
                                                                                // onClick={this.onClickCounter.bind(this, "tomorrowgeofence")}
                                                                                >
                                                                                    {/* <span className="f14">Load Taken From   Other <br /> OEMs in Last 24hrs</span> */}
                                                                                    <span className="f14">Carried Forward Trucks </span>
                                                                                    <div style={{ margin: '23px 0' }}></div> {/* Adds vertical spacing */}
                                                                                    {/* <h4 className="txt-warning f30"><span className="counter "><CountUp className="txt-warning" end={tmwoemcount} /></span></h4> */}
                                                                                    <br />
                                                                                    <h4 className="txt-warning f30"><span className="counter txt-warning">{tomorrow_trucks_expected_to_report}</span></h4>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ width: '100%' }}>
                                            <div className="row" style={{ marginBottom: '18px', width: '100%' }}>
                                                {/* {
                                                    this.state.selected_counter == "today" ? <span className="f14 pl-4">{isToday ? "Trucks Expected Today (Date)" : "Estimated Trucks"}</span> :
                                                        <span className="f14 pl-4">Trucks Expected Tomorrow (Tomorrow's Date)</span>
                                                } */}
                                            </div>
                                            <div style={{ width: '100%' }}>
                                                <HighchartsReact
                                                    highcharts={Highcharts}
                                                    options={options}
                                                    containerProps={{ style: { width: '100%', height: '400px' } }} // or any fixed height
                                                />
                                            </div>
                                            <div style={{ margin: '10px 0' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
                                                    <div>
                                                        Showing <strong>{paginatedData.length}</strong> of <strong>{groupedData.length}</strong> transporters
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <button
                                                            onClick={() => this.setState({ currentPage: 0 })}
                                                            disabled={currentPage === 0}
                                                            className="pagination-btn"
                                                        >
                                                            ⏮ First
                                                        </button>
                                                        <button
                                                            onClick={() => this.setState(prev => ({ currentPage: prev.currentPage - 1 }))}
                                                            disabled={currentPage === 0}
                                                            className="pagination-btn"
                                                        >
                                                            ⬅ Prev
                                                        </button>
                                                        {Array.from({ length: totalPages }, (_, i) => (
                                                            <button
                                                                key={i}
                                                                onClick={() => this.setState({ currentPage: i })}
                                                                className={`pagination-btn ${i === currentPage ? 'active' : ''}`}
                                                            >
                                                                {i + 1}
                                                            </button>
                                                        ))}
                                                        <button
                                                            onClick={() => this.setState(prev => ({ currentPage: prev.currentPage + 1 }))}
                                                            disabled={currentPage === totalPages - 1}
                                                            className="pagination-btn"
                                                        >
                                                            Next ➡
                                                        </button>
                                                        <button
                                                            onClick={() => this.setState({ currentPage: totalPages - 1 })}
                                                            disabled={currentPage === totalPages - 1}
                                                            className="pagination-btn"
                                                        >
                                                            Last ⏭
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {isToday &&
                                            <div id='gridMapContainer' className="row col-xl-12 col-lg-12 mt-4">
                                                <div className={"dataLoadpage " + (this.state.loadshow)}>
                                                </div>
                                                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                                                    <div class="loader-box">
                                                        <div class="loader-box">
                                                            <div class="rotate dashed colored">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row d-flex" style={{ width: '100%' }}>
                                                    <div className="f14 pl-4 mt-3">
                                                        <span>{map_container_title}</span>
                                                    </div>
                                                    <div className={"col " + (this.state.showrefresh)}>
                                                        {(this.state.tabplants.length > 0) ?
                                                            <div className="col-xl-12 d-flex justify-content-end mb-0">
                                                                <ul className="d-flex mpatabs">
                                                                    <li className={"btn " + (this.state.deftab == 'all' ? "btn-success" : "")} style={{ float: "left", padding: "10px", cursor: "pointer", background: "#eee", margin: "0px 0px 0px 5px" }} onClick={this.onClickShowMap.bind(this, 'all')}>All</li>
                                                                    {this.state.tabplants.map((item) =>
                                                                        <li className={"btn " + (this.state.deftab == item.plant_code ? "btn-success" : "")} style={{ float: "left", padding: "10px", cursor: "pointer", background: "#eee", margin: "0px 0px 0px 5px" }} onClick={this.onClickShowMap.bind(this, item)}>{item.plant_name}</li>
                                                                    )}
                                                                </ul>
                                                            </div>
                                                            : ""}
                                                        {/* <div className="col-xl-2 col-lg-2 float-right ">
                                                            <button type="button" style={{ marginRight: "30px" }} className={"btn btn-danger float-right"} onClick={this.goBack} >Back</button>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className={sel_sub_counter != 'todayloadedtrucks' ? "col-xl-6 col-lg-6 sidediv pt-2" : "col-xl-12 col-lg-12 sidediv pt-2"}>
                                                    {this.state.showAgGrid &&
                                                        renderAgGrid()
                                                    }
                                                </div>
                                                {sel_sub_counter != 'todayloadedtrucks' ?
                                                    <div className={this.state.showAgGrid == true ? "col-xl-6 col-lg-6" : "col-xl-12 col-lg-12"}>
                                                        <div className='sidediv'>
                                                            <div id="map_canvas" className={this.state.mwidth} style={dStyles}></div>
                                                        </div>
                                                    </div>
                                                    : ""
                                                }
                                            </div>
                                        }
                                        {!isToday &&
                                            <div id='gridMapContainer' className={"col-xl-12 col-lg-12 sidediv pt-2"}>
                                                {this.state.showAgGrid &&
                                                    <>
                                                        <div className="row pb-2" style={{ width: '100%' }}>
                                                            <span className="f14 pl-4">{map_container_title}</span>
                                                        </div>
                                                        {renderAgGrid()}

                                                    </>
                                                }
                                            </div>
                                        }
                                    </div>
                                </>
                            }
                            {activeTab == 2 &&
                                <>
                                    <ReturnLoadPercentage />
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (this.state.sliderBulkUpdate)} style={{ overflow: "auto" }}>
                    <div className="slide-r-title">
                        <h4>
                            Bulk Upload - Trucks
                            <span className="float-right closebtn" onClick={this.onClickHideAll.bind(this)} >X</span>
                        </h4>
                    </div>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div>
                        <div className={"row"} style={{ padding: '5px 0px', width: '100%', overflow: 'hidden', zIndex: '9999', height: "100em" }} >
                            <form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={this.submitBulkTrucks}>
                                <div className="col-xl-12 col-lg-12 row form-group">
                                    <label className="col-xl-12 col-lg-12">Upload File :</label>
                                    <div className="col-xl-12 col-lg-12 form-group">
                                        <input type="file"
                                            onChange={this.changeFileHandlerBulk}
                                            name="uploadFileBulk"
                                            id="uploadFileBulk"
                                            className="form-control"
                                            accept=".xls,.xlsx"
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-12 col-lg-12 form-group">
                                    <button type="submit" className="btn btn-success">Submit</button>
                                </div>
                                <div className="col-xl-12 col-lg-12 form-group">
                                    <a href={require("../../assets/json/samplebulkvehicleavailability.xlsx")} target="_blank" className="btn btn-warning">Download Sample Template</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (this.state.sliderTranslate)} >
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className={"dataLoadpage " + (this.state.loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                            <div class="loader-box">
                                <div class="loader-box">
                                    <div class="rotate dashed colored">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-12">
                            {this.displayData}
                        </div>
                    </div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>
        );
    }
}
function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
function initOMS() {
    oms = new oms.OverlappingMarkerSpiderfier(map, {
        markersWontMove: true,
        markersWontHide: true,
        keepSpiderfied: true,
        basicFormatEvents: true
    });
}
function secondsToHoursFormat(seconds) {
    try {
        const totalSeconds = Number(seconds);
        if (isNaN(totalSeconds) || totalSeconds < 0) {
            return '0 Hrs'; // Handle invalid input gracefully
        }
        const hours = totalSeconds / 3600;
        const formattedHours = hours.toFixed(1); // Round to 1 decimal place
        return `${formattedHours} Hrs`;
    } catch (e) {
        console.log("Error ", e);
        return '0 Hrs'; // fallback value
    }
}

function formatTillHour(hour) {
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `Till ${hour12} ${suffix}`;
}